
const MainServer = 'https://ba-tov-system-project.vercel.app'; // our main deploy server
const local = 'http://localhost:4000';

export default MainServer;
